import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, of } from "rxjs";

import { ISubscription } from "rxjs/Subscription";
import { PoItemModel } from "../../../../model/builk/po-item/poitem.model";
import { PoItemListModel } from "../../../../model/builk/po-item/poitem-list.model";
import { PoItemDetailComponent } from "../po-item-detail/po-item-detail.component";
import { SortCompanyModel } from "../../../../model/builk/company-manage/company-sort";
import { SortType } from "../../../../enum/builk/user-manager/sort-type";

@Component({
    selector: "bo-builk-po-item-table",
    templateUrl: "./po-item-table.component.html",
    styleUrls: ["./po-item-table.component.scss"]
})
export class PoItemTableComponent implements OnInit, OnDestroy {
    constructor(
        public router: Router
    ) { }

    @Output()
    sortOutput = new EventEmitter<SortCompanyModel>();
    private _data = new BehaviorSubject<Array<PoItemModel>>(
        new Array<PoItemModel>()
    );
    @Input()
    set getPoItemDataIndex(value) {
        this._data.next(value);
    }
    get getPoItemDataIndex(): Array<PoItemModel> {
        return this._data.getValue();
    }

    poItemResult: PoItemListModel = new PoItemListModel();

    @ViewChild("detailModal") detailModal: PoItemDetailComponent;

    poItem: PoItemModel = new PoItemModel();
    subscription: ISubscription;
    sortPoSurrKey: boolean;
    sortDocDate: boolean;
    sortItem: boolean;
    sortCompany: boolean;
    sortSupplier: boolean;
    sortQty: boolean;
    sortUnit: boolean;
    sortUnitPrice: boolean;
    sortVat: boolean;
    sortAmount: boolean;
    sortDeliverTo: boolean;
    sortCredit: boolean;
    sortCostCode: boolean;
    sortData: SortCompanyModel = new SortCompanyModel();

    ngOnInit(): void {
        this._data.subscribe(x => { });
    }

    openModal(id): void {
        this.detailModal.openModal(id);
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    // When click header call function
  sortStatus(event: any, status: boolean): void {
    this.sortPoSurrKey = false;
    this.sortDocDate = false;
    this.sortItem = false;
    this.sortCompany = false;
    this.sortSupplier = false;
    this.sortQty = false;
    this.sortUnit = false;
    this.sortUnitPrice = false;
    this.sortVat = false;
    this.sortAmount = false;
    this.sortDeliverTo = false;
    this.sortCredit = false;
    this.sortCostCode = false;
    if (status) {
      // sort to DESC
      this.sortPoSurrKey = false;
      this.sortDocDate = false;
      this.sortItem = false;
      this.sortCompany = false;
      this.sortSupplier = false;
      this.sortQty = false;
      this.sortUnit = false;
      this.sortUnitPrice = false;
      this.sortVat = false;
      this.sortAmount = false;
      this.sortDeliverTo = false;
      this.sortCredit = false;
      this.sortCostCode = false;

      this.sortData.sortCol = event;
      this.sortData.sortType = SortType.DESC;
      this.sortOutput.emit(this.sortData);
    } else {
      // sort to ASC
      if (event === "sortPoSurrKey") {
        this.sortPoSurrKey = true;
        this.sortData.sortCol = "poSurrkey";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortDocDate") {
        this.sortDocDate = true;
        this.sortData.sortCol = "docDate";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortItem") {
        this.sortItem = true;
        this.sortData.sortCol = "item";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortCompany") {
        this.sortCompany = true;
        this.sortData.sortCol = "company";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortSupplier") {
        this.sortSupplier = true;
        this.sortData.sortCol = "supplier";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortQty") {
        this.sortQty = true;
        this.sortData.sortCol = "qty";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortUnit") {
        this.sortUnit = true;
        this.sortData.sortCol = "unit";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortUnitPrice") {
        this.sortUnitPrice = true;
        this.sortData.sortCol = "unitPrice";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortVat") {
        this.sortVat = true;
        this.sortData.sortCol = "vat";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortAmount") {
        this.sortAmount = true;
        this.sortData.sortCol = "amount";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortDeliverTo") {
        this.sortDeliverTo = true;
        this.sortData.sortCol = "deliverTo";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortCredit") {
        this.sortCredit = true;
        this.sortData.sortCol = "credit";
        this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      } else if (event === "sortCostCode") {
          this.sortCostCode = true;
          this.sortData.sortCol = "costCode";
          this.sortData.sortType = SortType.ASC;
        this.sortOutput.emit(this.sortData);
      }
    }
  }
}
